module.exports = __webpack_public_path__ + "static/media/thumb-up.37c621b7.svg";